import { type NoTablesSchema, type NoValuesSchema } from "tinybase/with-schemas";

export const DEMO_TABLES_SCHEMA = {
    "demo-dts": {
        "phone": { type: "string", default: "" },
        "email": { type: "string", default: "" },
        "first_name": { type: "string", default: "" },
        "middle_name": { type: "string", default: "" },
        "last_name": { type: "string", default: "" },
        "user": { type: "string", default: "" },
        "photo": { type: "string", default: "" }, // Store UUID of the photo in the file table
        "synced": { type: "boolean", default: false },
        "deleted": { type: "boolean", default: false },
        "creation": { type: "string", default: new Date().toISOString() },
        "modified": { type: "string", default: new Date().toISOString() },
    }
} as const;

export type DemoSchema = [typeof DEMO_TABLES_SCHEMA, NoValuesSchema];

export const AUTH_VALUES_SCHEMA = {
    accessToken: { type: "string", default: "" },
    refreshToken: { type: "string", default: "" },
    expiresAt: { type: "number", default: 0 },
    isAuthenticated: { type: "boolean", default: false },
    setupCompleted: { type: "boolean", default: false },
    isLoading: { type: "boolean", default: true },
} as const;

export type AuthSchema = [NoTablesSchema, typeof AUTH_VALUES_SCHEMA];

export const USER_VALUES_SCHEMA = {
    id: { type: "string", default: "" },
    name: { type: "string", default: "" },
    email: { type: "string", default: "" },
    given_name: { type: "string", default: "" },
    family_name: { type: "string", default: "" },
    picture: { type: "string", default: "" },
    roles: { type: "string", default: "" },
} as const;

export type UserSchema = [NoTablesSchema, typeof USER_VALUES_SCHEMA];

export const APP_VALUES_SCHEMA = {
    theme: { type: "string", default: "system" },
    isSyncing: { type: "boolean", default: false },
} as const;

export type AppSchema = [NoTablesSchema, typeof APP_VALUES_SCHEMA];
